import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Modal,
    ModalHeader,
    ModalBody,
    Label,
    ListGroup,
    ListGroupItem,
    Row,
    Col,
    Input,
    InputGroup
} from 'reactstrap';
import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import ConfirmationScreen from '../settings/pos/ConfirmationScreen';
import { loadCategories, loadProducts, saveQuestion, deleteQuestion, publishQuestion, isQuestionCopy, saveQuestionCopy } from '../../../actions';
import {
    convertCheckBoxValueToBoolean,
    convertStringToBoolean,
    convertToLowerCase,
    posSupportsEditableFreeToppings
} from '../../../utils/CommonUtils';
import {
    MENU_ITEM_SUB_QUESTION,
    MENU_ITEM_TYPE_QUESTION
} from '../../../utils/Constants';
import BatchUpdateConfirmationScreen from './common/batchUpdate/BatchUpdateConfirmationScreen';
import PopoverCommon from './common/PopoverCommon';
import MenuPartsFooter from './common/MenuPartsFooter';
import MainInformation from './common/MainInformation';
import QuantityFields from './common/additionalInformation/QuantityFields';
import DependsOnQuestionsList from './common/dependsOn/DependsOnQuestionsList';

class QuestionScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentQuestion: {
                id: -1,
                name: '',
                active: false,
                canBeDeleted: false,
                canBePublished: false,
                published: false,
                canBeReassigned: false,
                description: '',
                minimumQuantity: null,
                maximumQuantity: null,
                multiIngredients: null,
                freeToppingsCount: null,
                productDraftId: -1,
                origin: '',
                answers: [],
                dependsOnQuestionId: -1,
                dependsOnAnswerIds: [],
                multipleActivateOrDeactivate: false,
                multipleNameChange: false,
                multipleDescriptionChange: false,
                answerGroups: [],
                ingredientQuestion: false,
                isCopyQuestion: false
            },
            answerGroupItem: '',
            answerGroupAlreadyInState: false,
            additionalInfo: false,
            hideDependsOn: true,
            modalSize: true,
            arrowIcon: true,
            dependsOnArrowIcon: false,
            stateAlreadyCopiedFromProps: false,
            originPopoverOpen: false,
            activePopoverOpen: false,
            tooltipOpen: false,
            publishTooltipOpen: false,
            selectedDependsOnQuestion: false,
            isBatchDeactivateBtnPressed: false,
            isDeleteBtnPressed: false
        }

        this.toggle = this.toggle.bind(this);
        this.changeState = this.changeState.bind(this);
        this.changeFreeToppingsCountState = this.changeFreeToppingsCountState.bind(this);
        this.saveQuestion = this.saveQuestion.bind(this);
        this.toggleOriginPopover = this.toggleOriginPopover.bind(this);
        this.toggleActivePopover = this.toggleActivePopover.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.togglePublishTooltip = this.togglePublishTooltip.bind(this);
        this.toggleBatchDeactivateConfirmation = this.toggleBatchDeactivateConfirmation.bind(this);
        this.changeAnswerGroupItemState = this.changeAnswerGroupItemState.bind(this);
        this.renderAdditionalInformation = this.renderAdditionalInformation.bind(this);
        this.renderDependsOn = this.renderDependsOn.bind(this);
        this.changeQuestionState = this.changeQuestionState.bind(this);
        this.changeAnswerState = this.changeAnswerState.bind(this);
        this.publishQuestion = this.publishQuestion.bind(this);
        this.saveCurrentQuestion = this.saveCurrentQuestion.bind(this);
        this.changeConfirmationType = this.changeConfirmationType.bind(this);
        this.handleCopyQuestion = this.handleCopyQuestion.bind(this);
    }

    componentWillUnmount() {
        this.resetModalState();
    }

    manageStateOnRender() {
        if (this.props.isOpen) {
            if (this.props.question !== undefined && this.props.question !== null &&
                this.props.question.id !== undefined && this.props.question.id !== -1 &&
                !this.state.stateAlreadyCopiedFromProps) {

                this.copyStateFromProps();
            }
        } else {
            this.resetModalState();
        }
    }

    copyStateFromProps() {
        this.setState(
            {
                currentQuestion: {
                    id: this.props.question.id,
                    name: this.props.question.name,
                    active: this.props.question.active,
                    canBeDeleted: this.props.question.canBeDeleted,
                    canBePublished: this.props.question.canBePublished,
                    published: this.props.question.published,
                    canBeReassigned: this.props.question.canBeReassigned,
                    description: this.props.question.description,
                    minimumQuantity: this.props.question.minimumQuantity,
                    maximumQuantity: this.props.question.maximumQuantity,
                    multiIngredients: this.props.question.multiIngredients,
                    // Add the ability for freeToppingsCount to be both 0 and null
                    freeToppingsCount: this.props.question.freeToppingsCount ? this.props.question.freeToppingsCount :
                        this.props.question.freeToppingsCount == 0 ? Number(this.props.question.freeToppingsCount) : '',
                    origin: this.props.question.origin,
                    productDraftId: this.props.productDraftId,
                    currentProductDraftId: this.props.productDraftId,
                    // currentProductDraftId is used for reloading answers in its group.
                    // In the flow productDraftId can be changed, that's why we
                    // are using questionId in loadQuestions action.
                    multipleActivateOrDeactivate: false,
                    multipleNameChange: false,
                    multipleDescriptionChange: false,
                    answers: this.props.answers,
                    dependsOnQuestionId: this.props.question.dependsOnQuestionId,
                    dependsOnAnswerIds: this.props.question.dependsOnAnswerIds, // for populating saved answers
                    answerGroups: this.props.question.answerGroups,
                    ingredientQuestion: this.props.question.ingredientQuestion,
                    isCopyQuestion: this.props.question.isCopyQuestion ? this.props.question.isCopyQuestion : false
                },
                stateAlreadyCopiedFromProps: true
            }
        )
    }

    changeFreeToppingsCountState({ target }) {
        this.setState({
            currentQuestion: {
                ...this.state.currentQuestion,
                [target.name]: target.value
            }
        });
    }

    changeState({ target }) {
        // For some reason, it accepts values "0" and "1" as false and true.
        // It is happening only in minimumQuantity and maximumQuantity.
        if (target.value !== 1 && target.value !== '1' && target.value !== 0 && target.value !== '0' && target.value !== '') {
            if (target.value == true || target.value == 'true' || target.value == false || target.value == 'false') {
                this.setState({
                    currentQuestion: {
                        ...this.state.currentQuestion,
                        [target.name]: convertCheckBoxValueToBoolean({ target })
                    }
                });
            } else {
                this.setState({
                    currentQuestion: {
                        ...this.state.currentQuestion,
                        [target.name]: target.value
                    }
                });
            }
        } else {
            this.setState({
                currentQuestion: {
                    ...this.state.currentQuestion,
                    [target.name]: target.value
                }
            });
        }

        if (target.name === 'menuDraftId') {
            this.props.loadCategories(Number(target.value));
            this.renderCategories();
        }

        if (target.name === 'categoryDraftId') {
            this.props.loadProducts(Number(target.value));
            this.renderProducts();
        }
    }

    changeQuestionState({ target }) {
        const checked = convertStringToBoolean(target.checked);

        if (checked == true) {
            this.setState({
                currentQuestion: {
                    ...this.state.currentQuestion,
                    dependsOnQuestionId: target.id,
                    dependsOnAnswerIds: []
                }
            });
        }

        if (checked == false) {
            this.setState({
                currentQuestion: {
                    ...this.state.currentQuestion,
                    dependsOnQuestionId: -1,
                    dependsOnAnswerIds: []
                }
            });
        }
    }

    changeAnswerState({ target }) {
        let checked = convertStringToBoolean(target.checked);

        if (checked == true && this.state.currentQuestion !== undefined && !this.state.currentQuestion.dependsOnAnswerIds.includes(target.id)) {
            this.setState({
                currentQuestion: {
                    ...this.state.currentQuestion,
                    dependsOnAnswerIds: [...this.state.currentQuestion.dependsOnAnswerIds, Number(target.id)]
                }
            });
        }

        if (checked == false && this.state.currentQuestion.dependsOnAnswerIds.includes(Number(target.id))) {
            this.setState({
                currentQuestion: {
                    ...this.state.currentQuestion,
                    dependsOnAnswerIds: this.state.currentQuestion.dependsOnAnswerIds.filter((checked) => checked != Number(target.id))
                }
            });
        }
    }

    changeConfirmationType({ target }) {

        this.setState({
            ...this.state,
            currentQuestion: {
                ...this.state.currentQuestion,
                [target.name]: target.value === 'true' ? true : false
            }
        });
    }

    getDependsOnQuestionName(currentDependsOnQuestionId) {
        const { dependsOnQuestions } = this.props;
        let dependsOnQestionName = '';

        for (let i = 0; i < dependsOnQuestions.length; i++) {
            if (Number(dependsOnQuestions[i].id) === Number(currentDependsOnQuestionId)) {
                dependsOnQestionName = dependsOnQuestions[i].name;

                return dependsOnQestionName;
            }
        }
    }

    toggle(saveOrPublish) {
        this.resetModalState();
        this.props.onToggle(this.state.currentQuestion, saveOrPublish, this.props.itemType);
    }

    toggleTooltip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    toggleActivePopover() {
        this.setState({
            activePopoverOpen: !this.state.activePopoverOpen
        });
    }

    toggleOriginPopover() {
        this.setState({
            originPopoverOpen: !this.state.originPopoverOpen
        });
    }

    togglePublishTooltip() {
        this.setState({
            publishTooltipOpen: !this.state.publishTooltipOpen
        });
    }

    renderActivePopover() {
        return (
            <PopoverCommon
                isOpen={this.state.activePopoverOpen}
                target="active"
                toggle={this.toggleActivePopover}
                textContent={i18n.t('screens:questionScreen.activePopover')}
            />
        );
    }

    renderOriginPopover() {
        const originMsg =
            (this.state.currentQuestion.origin !== undefined && this.state.currentQuestion.origin !== null
                && this.state.currentQuestion.origin !== '') ? this.state.currentQuestion.origin : i18n.t('common:popovers.origin');

        return (
            <PopoverCommon
                isOpen={this.state.originPopoverOpen}
                target="origin"
                toggle={this.toggleOriginPopover}
                textContent={originMsg}
            />
        );
    }

    resetModalState() {
        this.state.currentQuestion.id = -1;
        this.state.currentQuestion.name = '';
        this.state.currentQuestion.active = false;
        this.state.currentQuestion.canBeDeleted = false;
        this.state.currentQuestion.canBePublished = false;
        this.state.currentQuestion.published = false;
        this.state.currentQuestion.canBeReassigned = false;
        this.state.currentQuestion.description = '';
        this.state.currentQuestion.minimumQuantity = null;
        this.state.currentQuestion.maximumQuantity = null;
        this.state.currentQuestion.multiIngredients = '';
        this.state.currentQuestion.answers = [];
        this.state.currentQuestion.answerGroups = [];
        this.state.currentQuestion.isCopyQuestion = false,
        this.state.answerGroupItem = '';
        this.state.answerGroupAlreadyInState = false;
        this.state.additionalInfo = false;
        this.state.hideDependsOn = true;
        this.state.modalSize = true;
        this.state.arrowIcon = true;
        this.state.stateAlreadyCopiedFromProps = false;
        this.state.currentQuestion.dependsOnQuestionId = -1;
        this.state.currentQuestion.dependsOnAnswerIds = [];
        this.state.isBatchDeactivateBtnPressed = false;
        this.state.isDeleteBtnPressed = false;
        this.state.originPopoverOpen = false;
        this.state.activePopoverOpen = false;
        this.state.tooltipOpen = false;
        this.state.publishTooltipOpen = false;
    }

    toggleDeleteConfirmationWindow() {
        this.setState({
            ...this.state,
            isDeleteBtnPressed: !this.state.isDeleteBtnPressed
        });
    }

    toggleBatchDeactivateConfirmation() {
        this.setState({
            ...this.state,
            isBatchDeactivateBtnPressed: !this.state.isBatchDeactivateBtnPressed
        });
    }

    saveQuestion(publishQuestionCallback) {
        if (this.state.currentQuestion.id == -1 && this.props.productDraftId !== undefined && this.props.productDraftId !== -1) {
            this.state.currentQuestion.productDraftId = this.props.productDraftId;
        }

        if (this.state.currentQuestion.dependsOnQuestionId == undefined || this.state.currentQuestion.dependsOnQuestionId == null) {
            this.state.currentQuestion.dependsOnQuestionId = -1;
        }

        if (this.state.currentQuestion.id == -1 || (this.state.currentQuestion.active == this.props.question.active
            && this.state.currentQuestion.name === this.props.question.name && this.state.currentQuestion.description === this.props.question.description)) {

            this.saveCurrentQuestion(publishQuestionCallback);

            return;
        }

        if (!publishQuestionCallback) {
            this.toggleBatchDeactivateConfirmation();
        }
        // If called from publish button save question here without opening the modal
        if (publishQuestionCallback) {
            this.saveCurrentQuestion(publishQuestionCallback);
        }
    }

    saveCurrentQuestion(publishQuestionCallback) {
        const { restaurantId } = this.props;
        let dependsOnQuestionName = this.getDependsOnQuestionName(this.state.currentQuestion.dependsOnQuestionId);

        if (this.props.itemType === MENU_ITEM_SUB_QUESTION) {
            this.props.saveQuestion(this.state.currentQuestion, dependsOnQuestionName, restaurantId, this.props.productDraftPosId, true, publishQuestionCallback);
        } else {
            this.props.saveQuestion(this.state.currentQuestion, dependsOnQuestionName, restaurantId, this.props.productDraftPosId, false, publishQuestionCallback);
        }
        //save new question without depends on questions
        if (this.state.currentQuestion.dependsOnQuestionId == -1 && !publishQuestionCallback) {
            this.toggle(true);
            this.renderAdditionalInformation();
        }
        //save question with depends on questions and answers
        if (this.state.currentQuestion.dependsOnQuestionId !== -1 && this.state.currentQuestion.dependsOnAnswerIds.length > 0 && !publishQuestionCallback) {
            this.toggle(true);
            this.renderAdditionalInformation();
        }
    }

    deleteQuestion() {
        const { restaurantId } = this.props;

        if (this.props.itemType === MENU_ITEM_SUB_QUESTION) {
            this.props.deleteQuestion(this.state.currentQuestion, restaurantId, this.props.productDraftPosId, true);
        } else {
            this.props.deleteQuestion(this.state.currentQuestion, restaurantId, this.props.productDraftPosId, false);
        }

        this.toggle();
        this.renderAdditionalInformation();
    }

    customFormValidation() {
        let valid = true;
        const validName = this.state.currentQuestion.name !== '';

        if (!validName) {
            valid = false;
        } else if (this.state.currentQuestion.minimumQuantity && this.state.currentQuestion.maximumQuantity && this.state.currentQuestion.minimumQuantity > this.state.currentQuestion.maximumQuantity) {
            valid = false;
        }

        return valid;
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    publishQuestion() {
        const publishQuestionCallback = () => {
            const { restaurantId } = this.props;

            if (this.props.itemType === MENU_ITEM_SUB_QUESTION) {
                this.props.publishQuestion(this.state.currentQuestion, restaurantId, this.props.productDraftPosId, true);
            } else {
                this.props.publishQuestion(this.state.currentQuestion, restaurantId, this.props.productDraftPosId, false);
            }

            this.toggle(true);
        };

        // We can NOT use availability library validation on publish so we use custom one
        let valid = this.customFormValidation();
        if (!valid) {
            return;
        }

        this.saveQuestion(publishQuestionCallback);
    }

    renderAdditionalInformation() {
        if (this.state.modalSize && !this.state.hideDependsOn) {
            this.setState({
                hideDependsOn: !this.state.hideDependsOn,
                dependsOnArrowIcon: !this.state.dependsOnArrowIcon,

                additionalInfo: !this.state.additionalInfo,
                arrowIcon: !this.state.arrowIcon,
            });
        } else {
            this.setState({
                additionalInfo: !this.state.additionalInfo,
                modalSize: !this.state.modalSize,
                arrowIcon: !this.state.arrowIcon
            });
        }
    }

    renderDependsOn() {
        if (this.state.modalSize && !this.state.additionalInfo) {
            this.setState({
                additionalInfo: !this.state.additionalInfo,
                arrowIcon: !this.state.arrowIcon,

                hideDependsOn: !this.state.hideDependsOn,
                dependsOnArrowIcon: !this.state.dependsOnArrowIcon,
            });
        } else {
            this.setState({
                hideDependsOn: !this.state.hideDependsOn,
                modalSize: !this.state.modalSize,
                dependsOnArrowIcon: !this.state.dependsOnArrowIcon
            });
        }
    }

    renderCategories() {
        const { categories } = this.props;

        if (categories !== undefined && categories !== null && categories.length > 0) {
            return categories.map((item, i) => {
                return (
                    <option key={i} value={item.id}>{item.name}</option>
                );
            });
        }
    }

    renderProducts() {
        const { products } = this.props;

        if (products !== undefined && products !== null && products.length > 0) {
            return products.map((item, i) => {
                return (
                    <option key={i} value={item.id}>{item.name}</option>
                );
            });
        }
    }

    renderQuestionForm() {

        return (
            <AvForm id={-1} className="modalQuestionForm" onValidSubmit={() => { this.saveQuestion() }}>
                <ModalHeader className="modalHeader" toggle={this.toggle}>{i18n.t('screens:questionScreen.heading')}</ModalHeader>
                {this.renderModalBody()}
                {this.renderQuestionInfoFooter()}
            </AvForm>
        );
    }

    renderQuestionInfoFooter() {
        const publishTooltipMsg =
            (this.state.currentQuestion.id === undefined || this.state.currentQuestion.id === -1)
                ? i18n.t('common:popovers.newItemMsg') : i18n.t('screens:questionScreen.publishTooltip');

        const deleteTooltipMsg =
            (this.state.currentQuestion.id == -1 || this.state.currentQuestion.id == -1) ? i18n.t('common:popovers.newItemMsg')
                : (this.state.currentQuestion.canBeReassigned ? i18n.t('common:popovers.deleteMsg') : i18n.t('common:popovers.deleteQuestion'));

        const isDeleteDisabled =
            (this.state.currentQuestion !== undefined && this.state.currentQuestion !== null
                && !this.state.currentQuestion.canBeDeleted) ? true : false;
        
        const isCopyEnabled = !this.props.mealDealProduct && !this.state.currentQuestion.isCopyQuestion && this.state.currentQuestion.id !== -1;
        
        // (this.state.currentQuestion.name === undefined || this.state.currentQuestion.name === null || this.state.currentQuestion.name === '')
        //     || !this.props.mealDealProduct;
        
        return (
            <Fragment>
                <MenuPartsFooter
                    styles={styles}
                    state={this.state}
                    isPublishDisabled={!this.state.currentQuestion.canBePublished ? true : false}
                    publishTooltipMsg={publishTooltipMsg}
                    onClickPublish={this.publishQuestion}
                    publishTooltipToggle={this.togglePublishTooltip}
                    isDeleteDisabled={isDeleteDisabled}
                    deleteTooltipMsg={deleteTooltipMsg}
                    onClickDelete={this.toggleDeleteConfirmationWindow.bind(this)}
                    deleteTooltipToggle={this.toggleTooltip}
                    onClickOrigin={this.toggleOriginPopover}
                    isCopyProductButton={isCopyEnabled}
                    onClickCopy={this.handleCopyQuestion}
                />
                {this.renderOriginPopover()}
            </Fragment>
        );
    }

    handleCopyQuestion() {
        const currentQuestionId = this.state.currentQuestion.id;

        const currentQuestion = {...this.state.currentQuestion}
        currentQuestion.isCopyQuestion = true;
        
        currentQuestion.canBeDeleted = false;
        currentQuestion.canBePublished = false;
        currentQuestion.canBeReassigned = false;
       
        this.props.saveQuestionCopy(currentQuestion);
        this.toggle(false);
        this.props.isQuestionCopy(true);
    }

    renderModalBody() {
        const { checkboxLabel, listGroupItem, activeLabel, alignRight,
            cursorPointer, marginLeft, marginTop, activeProductCheckboxContainer, freeToppingsCounterContainer } = styles;
        let colSize = 12;
        let arrowIcon = 'keyboard_arrow_right';
        let dependsOnArrowIcon = 'keyboard_arrow_right';
        let activeInfo = '';
        let dependsOnActiveInfo = '';
        let iconColor = '#000';
        let dependsOnIconColor = '#000';

        if (this.state.modalSize === true) {
            if (!this.state.additionalInfo) {
                colSize = 8;
                arrowIcon = 'keyboard_arrow_left';
                activeInfo = 'active';
                iconColor = '#0288D1';
            }

            if (!this.state.hideDependsOn) {
                colSize = 8;
                dependsOnArrowIcon = 'keyboard_arrow_left';
                dependsOnActiveInfo = 'active';
                dependsOnIconColor = '#0288D1';
            }

        } else {
            if (!this.state.additionalInfo) {
                colSize = 12;
                arrowIcon = 'keyboard_arrow_right';
            }
            if (!this.state.hideDependsOn) {
                colSize = 12;
                dependsOnArrowIcon = 'keyboard_arrow_right';
            }
        }

        const isHidden = this.state.currentQuestion.id === -1 ? true : false;
        const reassignInfoMsg = (this.props.itemType === MENU_ITEM_SUB_QUESTION) ? i18n.t('screens:questionScreen.subQuestionReassign') : i18n.t('screens:questionScreen.cannotReassign');
        const isMsgHidden = (this.props.itemType === MENU_ITEM_SUB_QUESTION) ? false : (this.state.currentQuestion.canBeReassigned);
        const itemTypeIsQuestion = this.props.itemType === 'question';
        const itemIsMealDeal = this.props.mealDealProduct;
        
        return (
            <ModalBody>
                <Row>
                    <Col xs="12" sm={colSize}>
                        <MainInformation
                            styles={styles}
                            nameValue={this.state.currentQuestion.name}
                            onChange={this.changeState}
                            descriptionValue={this.state.currentQuestion.description}
                            draftName={'productDraftId'}
                            labelText={i18n.t('screens:questionScreen.reassign')}
                            options={this.props.products}
                            isDraftHidden={isHidden}
                            selectValue={this.state.currentQuestion.productDraftId}
                            isMsgHidden={isMsgHidden}
                            reassignInfoMsg={reassignInfoMsg}
                            itemType={this.props.itemType}
                        />
                        <Row>
                            <Col xs={12} sm={3}>
                                <AvGroup style={Object.assign({}, checkboxLabel, activeProductCheckboxContainer)} id="activeCheckboxGroup">
                                    <span onClick={this.toggleActivePopover} id="active" style={cursorPointer}>
                                        <MaterialIcon icon="help" color="#ff990a" size={20} />
                                    </span>
                                    {this.renderActivePopover()}
                                    <Label style={activeLabel} for="active">{i18n.t('common:buttons.active')}</Label>
                                    <AvInput type="checkbox" name="active"
                                        required={false}
                                        checked={!!this.state.currentQuestion.active}
                                        onChange={this.changeState}
                                        style={marginLeft} />
                                </AvGroup>
                            </Col>
                            <Col xs={12} sm={8}>
                                <AvGroup >
                                    <Label for="freeToppingsCount" style={activeLabel}>{i18n.t('screens:productScreen.freeToppings')}</Label>
                                    <AvInput type="number" name="freeToppingsCount"
                                        min="0"
                                        step="1"
                                        disabled={!posSupportsEditableFreeToppings(this.props.posSettings)}
                                        required={false}
                                        value={this.state.currentQuestion.freeToppingsCount}
                                        onChange={this.changeFreeToppingsCountState}
                                        style={freeToppingsCounterContainer} />
                                </AvGroup>
                            </Col>
                        </Row>
                        {
                            (this.props.posSettings.type.id !== 1 && this.props.posSettings.type.id !== 13) &&
                            <Row>
                                <Col xs={12}>
                                    <AvGroup>
                                        <Label for="ingredientQuestion" style={activeLabel}>{i18n.t('screens:questionScreen.ingredientQuestion')}</Label>
                                        <AvInput
                                            type='checkbox' name='ingredientQuestion' style={{ marginLeft: 10, marginTop: 6 }}
                                            required={false} checked={this.state.currentQuestion.ingredientQuestion}
                                            value={this.state.currentQuestion.ingredientQuestion}
                                            onChange={this.changeState} />
                                    </AvGroup>
                                </Col>
                            </Row>
                        }
                        <ListGroup onClick={this.renderAdditionalInformation} flush>
                            <ListGroupItem style={listGroupItem} className={activeInfo}>{i18n.t('common:buttons.additionalInfo')}
                                <span style={alignRight}><MaterialIcon icon={arrowIcon} color={iconColor} size={20} /></span>
                            </ListGroupItem>
                        </ListGroup>
                        <ListGroup onClick={this.renderDependsOn} hidden={itemTypeIsQuestion && itemIsMealDeal} style={marginTop} flush>
                            <ListGroupItem style={listGroupItem} className={dependsOnActiveInfo}>{i18n.t('common:buttons.dependsOn')}
                                <span style={alignRight}><MaterialIcon icon={dependsOnArrowIcon} color={dependsOnIconColor} size={20} /></span>
                            </ListGroupItem>
                        </ListGroup>
                    </Col>
                    {this.renderAdvancedInformation()}
                </Row>
            </ModalBody>
        );
    }

    renderConfirmationScreen() {
        let textData = {
            firstRow: i18n.t('screens:questionScreen.deleteMenuHeader'),
            header: i18n.t('screens:questionScreen.deleteMenuConfirmationText')
        };

        return (
            <ConfirmationScreen
                isOpen={this.state.isDeleteBtnPressed}
                onToggle={this.toggle}
                onSave={this.deleteQuestion.bind(this)}
                hasDeleteBtn={true}
                message={textData}
            />
        );
    }

    renderBatchDeactivateConfirmationScreen() {

        return (
            <BatchUpdateConfirmationScreen
                screen={'question'}
                isActive={this.state.currentQuestion.active}
                isOpen={this.state.isBatchDeactivateBtnPressed}
                onToggle={this.toggle}
                onSave={this.saveCurrentQuestion}
                onChange={this.changeConfirmationType}
                statusChanged={this.state.currentQuestion.active !== this.props.question.active}
                nameChanged={this.state.currentQuestion.name !== this.props.question.name}
                descriptionChanged={this.state.currentQuestion.description !== this.props.question.description}
            />
        );
    }

    renderAdvancedInformation() {
        const { checkboxLabel, marginLeft, fullWidthStyle, multiIngredientsLabel, scrollableAnswerGroup, addGroupButton,
            addGroupButtonDisabled, addAnswerGroupLabel, addAnswerGroupColumn } = styles;
        const isHidden = (this.props.itemType === MENU_ITEM_TYPE_QUESTION && this.props.mealDealProduct);
        const disableAddButton = this.state.answerGroupItem === '' ? addGroupButtonDisabled : (this.state.answerGroupAlreadyInState ? addGroupButtonDisabled : addGroupButton);

        if (!this.state.additionalInfo) {
            return (
                <Col>
                    <QuantityFields
                        minimumQuantity={this.state.currentQuestion.minimumQuantity}
                        maximumQuantity={this.state.currentQuestion.maximumQuantity}
                        changeState={this.changeState}
                        negativeDecimalsValidation={this.negativeDecimalsValidation.bind(this)}
                    />
                    <Row xs={12} sm={12} >
                        <AvGroup style={checkboxLabel}>
                            <Label style={multiIngredientsLabel} for="multiIngredients">{i18n.t('screens:questionScreen.multiIngredients')}</Label>
                            <AvInput type="checkbox" name="multiIngredients"
                                checked={this.state.currentQuestion.multiIngredients}
                                value={this.state.currentQuestion.multiIngredients}
                                onChange={this.changeState}
                                style={marginLeft} />
                        </AvGroup>
                    </Row>
                    <Row hidden={isHidden}>
                        <Col xs={12} sm={12}>
                            <AvGroup>
                                <Label style={addAnswerGroupLabel}>{i18n.t('screens:questionScreen.addAnswerGroupLabel')}</Label>
                                <Col style={addAnswerGroupColumn}>
                                    <AvInput
                                        type="text" name="answerGroupItem" placeholder={i18n.t('screens:questionScreen.addGroupsPlaceholder')}
                                        value={this.state.answerGroupItem} onChange={this.changeAnswerGroupItemState} />
                                    <span style={disableAddButton} onClick={() => this.addOrRemoveAnswerGroupItem('')}>
                                        <MaterialIcon icon="add_circle_outline" color="#0288D1" size={26} />
                                    </span>
                                </Col>
                            </AvGroup>
                        </Col>
                        <Col>
                            <ListGroup>
                                {this.renderAnswerGroups()}
                            </ListGroup>
                        </Col>
                    </Row>
                </Col>
            );
        } else if (!this.state.hideDependsOn) {

            return <DependsOnQuestionsList
                {...this.props}
                questionState={this.state.currentQuestion}
                changeQuestionState={this.changeQuestionState}
                changeAnswerState={this.changeAnswerState} />
        }
    }

    changeAnswerGroupItemState({ target }) {
        this.setState({
            ...this.state,
            [target.name]: target.value
        }, () => {
            this.state.currentQuestion.answerGroups.map(answerGroup => {
                if (convertToLowerCase(answerGroup.title) === convertToLowerCase(target.value)) {
                    this.setState({
                        ...this.state,
                        answerGroupAlreadyInState: true
                    });
                } else if (convertToLowerCase(answerGroup.title) !== convertToLowerCase(target.value)) {
                    this.setState({
                        ...this.state,
                        answerGroupAlreadyInState: false
                    });
                }
            });
        });
    }

    addOrRemoveAnswerGroupItem(currentItem) {
        const newAnswerGroups = this.state.currentQuestion.answerGroups.slice(0);
        let newAnswerGroup = { id: null, title: this.state.answerGroupItem };
        let groupAlreadyExists = false;

        if (this.state.currentQuestion.answerGroups.length === 0) {
            newAnswerGroups.push(newAnswerGroup);
        } else if (currentItem !== '') {
            this.state.currentQuestion.answerGroups.map(answer => {
                if (answer.title === currentItem) {
                    const answerIndex = this.state.currentQuestion.answerGroups.indexOf(answer);
                    newAnswerGroups.splice(answerIndex, 1);
                }
            });
        } else {
            this.state.currentQuestion.answerGroups.map(answer => {
                if (answer.title === this.state.answerGroupItem) {
                    groupAlreadyExists = true;
                }
            });

            if (!groupAlreadyExists) {
                newAnswerGroups.push(newAnswerGroup);
            }
        }

        this.setState({
            currentQuestion:
            {
                ...this.state.currentQuestion,
                answerGroups: newAnswerGroups
            }
        }, () => {
            this.setState({
                ...this.state,
                answerGroupItem: ''
            });
        });
    }

    renderAnswerGroups() {
        const { answerGroupListItem, removeAnswerGroupItem } = styles;

        if (this.state.currentQuestion.answerGroups !== undefined && this.state.currentQuestion.answerGroup !== null) {
            return this.state.currentQuestion.answerGroups.map((answer, i) => {

                return (
                    <ListGroupItem key={`answerGroup${i}`} style={answerGroupListItem}>
                        <span>{answer.title}</span>
                        <span onClick={() => this.addOrRemoveAnswerGroupItem(answer.title)} style={removeAnswerGroupItem}><MaterialIcon icon="clear" color="#000" size={20} /></span>
                    </ListGroupItem>
                );
            });
        }
    }

    renderDependsOnAnswers(dependsOnQuestion) {
        const { checkboxLabel, fullWidthStyle, dependsOnListItem } = styles;

        return (
            <ListGroup style={fullWidthStyle}>
                {
                    dependsOnQuestion.answerDraftDtos.map((answerDraftDto, i) => {
                        return (
                            <ListGroupItem key={i} style={dependsOnListItem}>
                                <Row>
                                    <Col xs={2} sm={1}>
                                        <InputGroup style={checkboxLabel}>
                                            <Input type="checkbox" name="dependsOnAnswerIds" id={answerDraftDto.id}
                                                checked={this.getSelectedDependsOnAnswer(answerDraftDto.id)}
                                                onChange={this.changeAnswerState} />
                                        </InputGroup>
                                    </Col>
                                    <Col className="longerNamesStyle">{answerDraftDto.name}</Col>
                                </Row>
                            </ListGroupItem>
                        );
                    })
                }
            </ListGroup>
        );
    }

    render() {
        this.manageStateOnRender();

        let modalSize = '';

        if (this.state.modalSize === true && !this.state.saveUnactiveQuestionPressed && !this.state.saveActiveQuestionPressed) {
            modalSize = 'lg'
        } else {
            modalSize = 'md'
        }

        return (
            <div>
                <Modal isOpen={this.props.isOpen} toggle={this.toggle} size={modalSize}>
                    {(!this.state.isDeleteBtnPressed) ? (this.state.isBatchDeactivateBtnPressed) ? this.renderBatchDeactivateConfirmationScreen() : this.renderQuestionForm() : this.renderConfirmationScreen()}
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        menus: state.menus,
        categories: state.categories,
        products: state.products,
        posSettings: state.posSettings,
        dependsOnQuestions: state.dependsOnQuestions,
        productCopy: state.productCopy
    };
};

export default connect(mapStateToProps, { loadCategories, loadProducts, saveQuestion, deleteQuestion, publishQuestion, isQuestionCopy, saveQuestionCopy })(QuestionScreen);

let styles = {
    checkboxLabel: {
        paddingLeft: '0.2rem',
        width: '100%'
    },
    descriptionStyle: {
        height: 75
    },
    listGroupItem: {
        display: 'flex',
        background: 'none',
        borderBottom: '1px solid #dee2e7',
        cursor: 'pointer',
        borderTop: 'none',
        paddingLeft: '0.2rem',
        paddingRight: 0,
        paddingTop: 0
    },
    originStyle: {
        color: '#0288d1',
        marginRight: 'auto',
        padding: 0,
    },
    activeLabel: {
        marginLeft: 6
    },
    alignRight: {
        marginLeft: 'auto'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    marginLeft: {
        marginLeft: 10
    },
    popoverStyle: {
        padding: '12px 6px 0px 6px'
    },
    fullWidthStyle: {
        width: '100%'
    },
    // dependsOnListItem: {
    //     border: 'none',
    //     background: 'none',
    //     height: 32,
    //     paddingBottom: 0
    // },
    // topMainListItem: {
    //     border: 'none',
    //     borderBottom: '1px solid #dee2e7',
    //     background: 'none',
    //     paddingBottom: 8,
    //     paddingTop: 0
    // },
    // mainListItem: {
    //     border: 'none',
    //     borderBottom: '1px solid #dee2e7',
    //     background: 'none',
    //     paddingBottom: 8,
    // },
    marginTop: {
        marginTop: 14
    },
    answerGroup: {
        marginLeft: 25
    },
    multiIngredientsLabel: {
        marginLeft: 12
    },
    scrollableAnswerGroup: {
        overflowY: 'auto',
        height: 420
    },
    additionalTextInfo: {
        marginLeft: 5
    },
    textInfo: {
        color: '#737373',
        fontSize: 12
    },
    spaceBetween: {
        paddingLeft: 4
    },
    addGroupButton: {
        display: 'flex',
        alignSelf: 'center',
        cursor: 'pointer',
        marginLeft: 8
    },
    addGroupButtonDisabled: {
        display: 'flex',
        alignSelf: 'center',
        marginLeft: 8,
        pointerEvents: 'none'
    },
    addAnswerGroupLabel: {
        height: 35,
        marginBottom: 0
    },
    addAnswerGroupColumn: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: 0
    },
    answerGroupListItem: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '1px 0 1px 10px',
        marginBottom: 6,
        border: 'none',
        borderBottom: '1px solid #ced4da',
        borderRadius: 0,
        backgroundColor: '#F8F8F8',
    },
    removeAnswerGroupItem: {
        cursor: 'pointer'
    },
    activeProductCheckboxContainer: {
        position: 'relative',
        top: 13
    },
    freeToppingsCounterContainer: {
        width: 103,
        display: 'inline-block',
        marginLeft: 10
    },
    inputCounter: {
        textAlign: 'right',
        fontSize: 12,
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/QuestionScreen.js